<section class="editor-panel">

  <!-- ② Section -->
  <ng-container
    *ngIf="style?.hasOwnProperty('background') || style?.hasOwnProperty('layout') || (style?.hasOwnProperty('headline') && style?.headline) || (content.hasOwnProperty('numberOfColumns') && content.hasOwnProperty('numberOfRows')) || style?.contentBackground || style?.border || style?.hasOwnProperty('devider') || (style?.hasOwnProperty('animation') && style?.animation) || style?.hasOwnProperty('styling') || style?.hasOwnProperty('footerType') || style?.hasOwnProperty('sticky') || style?.hasOwnProperty('pricingStyle') || style?.hasOwnProperty('customization') || style?.hasOwnProperty('enableHeaderCarousel') || (style?.hasOwnProperty('menuType') && businessType === 'E_COMMERCE')">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('section')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M9 3v18" />
        </svg>
        <span class="design-group__badge" style="display:none">2</span>
        <span class="design-group__title">General</span>
        <svg class="design-group__chevron" [class.open]="openSections['section']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['section']">

        <!-- Background -->
        <ng-container *ngIf="style?.hasOwnProperty('background')">

          <!-- SECTION TITLE -->
          <p class="section-heading">Background</p>

          <!-- COLOR -->
          <div class="prop-row" (click)="openBackgroundColorEditor()" style="cursor:pointer;">

            <span class="prop-label">Color</span>

            <div class="color-chip" [style.background]="
        style?.background?.backgroundType === 'Solid'
          ? style?.background?.color
          : 'linear-gradient('
            + getBackgroundDirection(style?.background?.backgroundGradientDirection)
            + ', '
            + style?.background?.color
            + ', '
            + style?.background?.secondaryColor
            + ')'
      ">
            </div>

          </div>

          <!-- IMAGE -->
          <div *ngIf="style?.background?.hasOwnProperty('image')">

            <div class="prop-row">

              <!-- LEFT -->
              <div class="background-image-left">
                <span class="prop-label">Image</span>
              </div>
              <!-- RIGHT -->
              <div class="background-image-right">
                <div *ngIf="style?.background?.showImage" class="background-thumb cusor-pointer" (click)="updateBGImage($event)">
                  <img *ngIf="style?.background?.image" [src]="style?.background?.image" alt="background">
                </div>
                <!-- REPLACE ICON
                <button *ngIf="style?.background?.showImage" class="replace-icon-btn">

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    width="15" height="15">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                      d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                  </svg>
                </button> -->

                <!-- TOGGLE -->
                <input class="toggle-input" type="checkbox" [(ngModel)]="style.background.showImage"
                  (change)="toggleBackgroundImage()" role="switch" [class.active]="style?.background?.showImage">

              </div>

            </div>

            <!-- HIDDEN IMAGE EDITOR -->
            <div *ngIf="style?.background?.showImage">
              <app-background-image-editor *ngIf="style?.background?.showImage" [data]="style.background"
                [componentId]="componentId">
              </app-background-image-editor>
            </div>
          </div>
        </ng-container>


        <!-- Layout -->
        <ng-container *ngIf="style?.hasOwnProperty('layout')">
          <div class="design-group__divider"></div>
          <p class="section-heading">Layout</p>
          <div *ngIf="style?.layout?.hasOwnProperty('setContentPosition')" class="prop-row">
            <span class="prop-label">Content width</span>
            <mat-form-field appearance="outline" style="width:140px;">
              <mat-select [(ngModel)]="style.layout.setContentPosition">
                <ng-container *ngFor="let item of setContentPosition">
                  <mat-option [value]="item">{{ item }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="style?.layout?.hasOwnProperty('imagePosition')" class="prop-row">
            <span class="prop-label">Image position</span>
            <mat-form-field appearance="outline" style="width:140px;">
              <mat-select [(ngModel)]="style.layout.imagePosition">
                <ng-container *ngFor="let item of setContentPosition">
                  <mat-option [value]="item">{{ item }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="style?.hasOwnProperty('positionLayout')" class="prop-row">
            <span class="prop-label">{{style?.positionLayout?.lable}}</span>
            <div class="pills">
              <div class="pill-left" (click)="changeLayoutAlignment('left')"
                *ngIf="style?.positionLayout?.types?.includes('left')"
                [ngClass]="{'pill-active': style?.positionLayout?.value === 'left'}" matTooltip="Left"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                  <path
                    d="M2.25 7c0-1.24264 1.00736-2.25 2.25-2.25h2c1.24264 0 2.25 1.00736 2.25 2.25v6c0 1.2426-1.00736 2.25-2.25 2.25h-2c-1.24264 0-2.25-1.0074-2.25-2.25V7Zm2.25-.75c-.41421 0-.75.33579-.75.75v6c0 .4142.33579.75.75.75h2c.41421 0 .75-.3358.75-.75V7c0-.41421-.33579-.75-.75-.75h-2ZM11.25 6c0-.41421.3358-.75.75-.75h3c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-3c-.4142 0-.75-.33579-.75-.75Zm0 4c0-.41421.3358-.75.75-.75h5c.4142 0 .75.33579.75.75 0 .4142-.3358.75-.75.75h-5c-.4142 0-.75-.3358-.75-.75Zm0 4c0-.4142.3358-.75.75-.75h4c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-4c-.4142 0-.75-.3358-.75-.75Z" />
                </svg>
              </div>
              <div class="pill-mid" (click)="changeLayoutAlignment('right')"
                *ngIf="style?.positionLayout?.types?.includes('right')"
                [ngClass]="{'pill-active': style?.positionLayout?.value === 'right'}" matTooltip="Right"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                  <path
                    d="M2.25 6c0-.41421.33579-.75.75-.75h3c.41421 0 .75.33579.75.75s-.33579.75-.75.75H3c-.41421 0-.75-.33579-.75-.75Zm0 4c0-.41421.33579-.75.75-.75h5c.41421 0 .75.33579.75.75 0 .4142-.33579.75-.75.75H3c-.41421 0-.75-.3358-.75-.75Zm0 4c0-.4142.33579-.75.75-.75h4c.41421 0 .75.3358.75.75s-.33579.75-.75.75H3c-.41421 0-.75-.3358-.75-.75Zm9-7c0-1.24264 1.0074-2.25 2.25-2.25h2c1.2426 0 2.25 1.00736 2.25 2.25v6c0 1.2426-1.0074 2.25-2.25 2.25h-2c-1.2426 0-2.25-1.0074-2.25-2.25V7Zm2.25-.75c-.4142 0-.75.33579-.75.75v6c0 .4142.3358.75.75.75h2c.4142 0 .75-.3358.75-.75V7c0-.41421-.3358-.75-.75-.75h-2Z" />
                </svg>
              </div>
              <div class="pill-mid" (click)="changeLayoutAlignment('top')"
                *ngIf="style?.positionLayout?.types?.includes('top')"
                [ngClass]="{'pill-active': style?.positionLayout?.value === 'top'}" matTooltip="Top"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                  <path
                    d="M5.25 4.5c0-1.24264 1.00736-2.25 2.25-2.25h5c1.2426 0 2.25 1.00736 2.25 2.25v3c0 1.24264-1.0074 2.25-2.25 2.25h-5c-1.24264 0-2.25-1.00736-2.25-2.25v-3Zm2.25-.75c-.41421 0-.75.33579-.75.75v3c0 .41421.33579.75.75.75h5c.4142 0 .75-.33579.75-.75v-3c0-.41421-.3358-.75-.75-.75h-5ZM5.25 13c0-.4142.33579-.75.75-.75h8c.4142 0 .75.3358.75.75s-.3358.75-.75.75H6c-.41421 0-.75-.3358-.75-.75Zm-2 4c0-.4142.33579-.75.75-.75h12c.4142 0 .75.3358.75.75s-.3358.75-.75.75H4c-.41421 0-.75-.3358-.75-.75Z" />
                </svg>
              </div>
              <div class="pill-right" (click)="changeLayoutAlignment('bottom')"
                *ngIf="style?.positionLayout?.types?.includes('bottom')"
                [ngClass]="{'pill-active': style?.positionLayout?.value === 'bottom'}" matTooltip="Bottom"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                  <path
                    d="M5.25 3c0-.41421.33579-.75.75-.75h8c.4142 0 .75.33579.75.75s-.3358.75-.75.75H6c-.41421 0-.75-.33579-.75-.75Zm-2 4c0-.41421.33579-.75.75-.75h12c.4142 0 .75.33579.75.75s-.3358.75-.75.75H4c-.41421 0-.75-.33579-.75-.75Zm2 5.5c0-1.2426 1.00736-2.25 2.25-2.25h5c1.2426 0 2.25 1.0074 2.25 2.25v3c0 1.2426-1.0074 2.25-2.25 2.25h-5c-1.24264 0-2.25-1.0074-2.25-2.25v-3Zm2.25-.75c-.41421 0-.75.3358-.75.75v3c0 .4142.33579.75.75.75h5c.4142 0 .75-.3358.75-.75v-3c0-.4142-.3358-.75-.75-.75h-5Z" />
                </svg>
              </div>
            </div>
          </div>
          <div *ngIf="style?.layout?.fit" class="prop-row">
            <span class="prop-label">Section size</span>
            <div class="pills">
              <div *ngFor="let height of minHeight; let i = index" (click)="changeMinHeight(height.type)"
                [ngClass]="{'pill-active': height?.type === style?.layout?.fit, 'pill-left': i == 0, 'pill-right': i == minHeight.length - 1}"
                [matTooltip]="(height?.type | titlecase) || ''" matTooltipPosition="above">
                {{height?.type | titlecase}}
              </div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('gridStyle')" class="prop-row">
            <span class="prop-label">Grid style</span>
            <div class="pills">
              <div *ngFor="let grid of gridStyle; let i = index" (click)="style.gridStyle = grid?.type"
                [ngClass]="{'pill-active': style?.gridStyle === grid?.type, 'pill-left': i == 0, 'pill-right': i == gridStyle.length - 1}"
                [matTooltip]="(grid?.type | titlecase) || ''" matTooltipPosition="above">
                {{grid?.type | titlecase}}
              </div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('showCaseType')" class="prop-row">
            <span class="prop-label">Showcase Type</span>
            <div class="pills">
              <div *ngFor="let showcase of showcasetype; let i = index" (click)="style.showCaseType = showcase?.type"
                [ngClass]="{'pill-active': showcase?.type === style?.showCaseType, 'pill-left': i == 0, 'pill-right': i == showcasetype.length - 1}"
                [matTooltip]="(showcase?.type | titlecase) || ''" matTooltipPosition="above">
                {{showcase?.type | titlecase}}</div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('maximumProduct')" class="mt-10">
            <p class="prop-label">Maximum products to show</p>
            <div class="slider-row">
              <mat-slider style="flex:1;" [max]="maximumProduct" [min]="min" [step]="step">
                <input matSliderThumb [(ngModel)]="style.maximumProduct">
              </mat-slider>
              <span class="slider-val">{{style?.maximumProduct}}</span>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('elementInRow') && style?.theme === 'Theme1'" class="mt-10">
            <p class="prop-label">Columns on desktop</p>
            <div class="slider-row">
              <mat-slider style="flex:1;" [max]="maxElementInRow" [min]="rowMin" [step]="step">
                <input matSliderThumb [(ngModel)]="style.elementInRow">
              </mat-slider>
              <span class="slider-val">{{style?.elementInRow}}</span>
            </div>
          </div>
          <div *ngIf="style?.mobileColumn" class="prop-row">
            <span class="prop-label">Columns on mobile</span>
            <div class="pills">
              <div class="pill-left" [ngClass]="{'pill-active': style?.mobileColumn === 1}"
                (click)="style.mobileColumn = 1" matTooltip="1 column" matTooltipPosition="above">1</div>
              <div class="pill-right" [ngClass]="{'pill-active': style?.mobileColumn === 2}"
                (click)="style.mobileColumn = 2" matTooltip="2 columns" matTooltipPosition="above">2</div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('direction') && style?.gridStyle != 'Style2'" class="prop-row">
            <span class="prop-label">Wrap direction</span>
            <div class="pills">
              <div *ngFor="let wrapOption of flexWrapOptions; let i = index" (click)="changeWrapOption(wrapOption)"
                [ngClass]="{'pill-active': wrapOption === style?.direction, 'pill-left': i == 0, 'pill-right': i == minHeight.length - 1}"
                [matTooltip]="(wrapOption | titlecase) || ''" matTooltipPosition="above">
                {{wrapOption | titlecase}}
              </div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('logoSpeed') && style?.showCaseType === showCaseEnum.Carousal"
            class="prop-row">
            <span class="prop-label">Carousel speed</span>
            <mat-form-field appearance="outline" style="width:130px;">
              <mat-select [(ngModel)]="style.logoSpeed">
                <ng-container *ngFor="let item of carouselSpeed">
                  <mat-option [value]="item?.type">{{item?.view | titlecase}}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="style?.hasOwnProperty('logoDirection') && style?.showCaseType === showCaseEnum.Carousal"
            class="prop-row">
            <span class="prop-label">Direction</span>
            <div class="pills">
              <div class="pill-left" (click)="style.logoDirection = carouselDirectionEnum.Left"
                [ngClass]="{'pill-active': style?.logoDirection === carouselDirectionEnum.Left}" matTooltip="Left"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                  height="16">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
              </div>
              <div class="pill-right" (click)="style.logoDirection = carouselDirectionEnum.Right"
                [ngClass]="{'pill-active': style?.logoDirection === carouselDirectionEnum.Right}" matTooltip="Right"
                matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                  height="16">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </div>
            </div>
          </div>
          <div class="prop-row" *ngIf="style?.hasOwnProperty('merge')">
            <span class="prop-label">Combine with header</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.merge" role="switch"
              [class.active]="style?.merge">
          </div>
          <div class="prop-row" *ngIf="style?.hasOwnProperty('removeGaps')">
            <span class="prop-label">Remove gaps</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.removeGaps" role="switch"
              [class.active]="style?.removeGaps">
          </div>
          <div class="prop-row" *ngIf="style?.hasOwnProperty('fullWidth')">
            <span class="prop-label">Full width</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.fullWidth" role="switch"
              [class.active]="style?.fullWidth">
          </div>
          <div class="prop-row" *ngIf="style?.hasOwnProperty('cartItemsStyling')">
            <span class="prop-label">Cart items styling</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.cartItemsStyling" role="switch"
              [class.active]="style?.cartItemsStyling" (ngModelChange)="showDummyCartItems()">
          </div>

          <!-- Theme (merged from former Theme group) -->
          <ng-container
            *ngIf="style?.hasOwnProperty('styling') || style?.hasOwnProperty('footerType') || style?.hasOwnProperty('sticky') || style?.hasOwnProperty('pricingStyle') || style?.hasOwnProperty('customization') || (style?.hasOwnProperty('menuType') && businessType === 'E_COMMERCE') || style?.hasOwnProperty('stickyType') || style?.hasOwnProperty('mobileMenuType')">
            <div class="design-group__divider"></div>
            <p class="item-sub-label">Theme</p>
            <!-- Combined Header Layout Picker -->
            <ng-container *ngIf="style?.hasOwnProperty('styling') && style?.hasOwnProperty('menuType')">
              <p class="prop-label" style="margin-bottom:6px;">Layout</p>
              <div class="layout-picker" (click)="$event.stopPropagation()">

                <!-- Trigger -->
                <div class="layout-trigger mb-2" (click)="showLayoutPicker = !showLayoutPicker">
                  <ng-container *ngIf="selectedLayoutOption; else noSelection">
                    <div class="layout-preview-thumb">
                      <ng-container [ngSwitch]="selectedLayoutOption.styling + '_' + selectedLayoutOption.menuType">
                        <ng-container *ngSwitchCase="'Header1_MEGA_MENU'"     [ngTemplateOutlet]="svgH1Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header1_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH1Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header2_MEGA_MENU'"     [ngTemplateOutlet]="svgH2Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header2_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH2Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header3_MEGA_MENU'"     [ngTemplateOutlet]="svgH3Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header3_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH3Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header4_MEGA_MENU'"     [ngTemplateOutlet]="svgH4Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header4_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH4Drop"></ng-container>
                      </ng-container>
                    </div>
                    <div class="layout-trigger-info">
                      <span class="layout-title">{{ selectedLayoutOption.title }}</span>
                      <span class="layout-subtitle">{{ selectedLayoutOption.subtitle }}</span>
                    </div>
                  </ng-container>
                  <ng-template #noSelection>
                    <span class="layout-placeholder">Select layout…</span>
                  </ng-template>
                  <svg class="layout-chevron" [class.open]="showLayoutPicker"
                       xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6"/>
                  </svg>
                </div>

                <!-- Dropdown panel -->
                <div class="layout-dropdown" *ngIf="showLayoutPicker">
                  <div class="layout-item"
                       *ngFor="let option of headerLayoutOptions"
                       [class.layout-item-active]="option.styling === style?.styling && option.menuType === style?.menuType"
                       (click)="selectLayout(option)">
                    <div class="layout-preview-thumb">
                      <ng-container [ngSwitch]="option.styling + '_' + option.menuType">
                        <ng-container *ngSwitchCase="'Header1_MEGA_MENU'"     [ngTemplateOutlet]="svgH1Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header1_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH1Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header2_MEGA_MENU'"     [ngTemplateOutlet]="svgH2Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header2_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH2Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header3_MEGA_MENU'"     [ngTemplateOutlet]="svgH3Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header3_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH3Drop"></ng-container>
                        <ng-container *ngSwitchCase="'Header4_MEGA_MENU'"     [ngTemplateOutlet]="svgH4Mega"></ng-container>
                        <ng-container *ngSwitchCase="'Header4_DROPDOWN_MENU'" [ngTemplateOutlet]="svgH4Drop"></ng-container>
                      </ng-container>
                    </div>
                    <div class="layout-item-info">
                      <span class="layout-title">{{ option.title }}</span>
                      <span class="layout-subtitle">{{ option.subtitle }}</span>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>

            <!-- Header Styling pills (non-menu sections that have styling but not menuType) -->
            <ng-container *ngIf="style?.hasOwnProperty('styling') && !style?.hasOwnProperty('menuType')">
              <div>
                <p class="prop-label" style="margin-bottom:6px;">Header Styling</p>
                <div class="pills pills-full">
                  <div *ngFor="let item of headerStyling; let i = index" (click)="style.styling = item"
                    [ngClass]="{'pill-active': style?.styling === item, 'pill-left': i === 0, 'pill-right': i === headerStyling.length - 1}"
                    [matTooltip]="(item | titlecase) || ''" matTooltipPosition="above">
                    {{ item | titlecase }}</div>
                </div>
              </div>
            </ng-container>
            <!-- <div class="prop-row" *ngIf="style?.hasOwnProperty('sticky')">
              <span class="prop-label">Sticky</span>
              <input class="toggle-input" type="checkbox" [(ngModel)]="style.sticky" role="switch"
                [class.active]="style?.sticky">
            </div> -->
            <div class="prop-row" *ngIf="style?.hasOwnProperty('stickyType')">
              <span class="prop-label">Sticky Type</span>
              <mat-form-field appearance="outline" style="width:160px;">
                <mat-select [(ngModel)]="style.stickyType">
                  <ng-container *ngFor="let item of stickyTypeOptions">
                    <mat-option [value]="item">{{ item | titlecase }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="prop-row" *ngIf="style?.hasOwnProperty('mobileMenuType')">
              <span class="prop-label">Mobile Menu</span>
              <mat-form-field appearance="outline" style="width:160px;">
                <mat-select [(ngModel)]="style.mobileMenuType">
                  <ng-container *ngFor="let item of mobileMenuTypeOptions">
                    <mat-option [value]="item">{{ item | titlecase }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="style?.hasOwnProperty('footerType')">
              <p class="prop-label" style="margin-bottom:6px;">Footer Styling</p>
              <div class="pills pills-full">
                <div *ngFor="let item of footerType; let i = index" (click)="style.footerType = item?.type"
                  [ngClass]="{'pill-active': style?.footerType === item?.type, 'pill-left': i === 0, 'pill-right': i === footerType.length - 1}"
                  [matTooltip]="(item?.type | titlecase) || ''" matTooltipPosition="above">
                  {{ item?.type | titlecase }}</div>
              </div>
            </div>
            <div *ngIf="style?.pricingStyle" class="prop-row">
              <span class="prop-label">Pricing Theme</span>
              <div class="pills">
                <div *ngFor="let item of pricingStyleType; let i = index" (click)="style.pricingStyle = item?.type"
                  [ngClass]="{'pill-active': style?.pricingStyle === item?.type, 'pill-left': i === 0, 'pill-right': i === pricingStyleType.length - 1}"
                  [matTooltip]="(item?.type | titlecase) || ''" matTooltipPosition="above">
                  {{ item?.type | titlecase }}</div>
              </div>
            </div>
            <div *ngIf="style?.hasOwnProperty('customization')" class="prop-row">
              <span class="prop-label">Variant Style</span>
              <div class="pills">
                <div *ngFor="let item of gridStyle; let i = index" (click)="style.customization = item?.type"
                  [ngClass]="{'pill-active': style?.customization === item?.type, 'pill-left': i === 0, 'pill-right': i === gridStyle.length - 1}"
                  [matTooltip]="(item?.type | titlecase) || ''" matTooltipPosition="above">
                  {{ item?.type | titlecase }}</div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Spacing -->
        <ng-container
          *ngIf="style?.layout?.spacingHorizontal || style?.layout?.spacing?.top || style?.layout?.spacing?.bottom || style?.layout?.spacingAround">
          <div class="design-group__divider"></div>
          <p class="section-heading">Spacing</p>
          <div *ngIf="style?.layout?.spacingHorizontal" class="prop-row">
            <span class="prop-label">Padding X</span>
            <div class="pills pills-spacing">
              <div *ngFor="let item of spacingType; let i = index" (click)="changeSpacingHorizontal(item.type)"
                [ngClass]="{'pill-active': style?.layout?.spacingHorizontal === item?.type, 'pill-left': i === 0, 'pill-right': i === spacingType.length - 1}"
                [matTooltip]="item?.view || ''" matTooltipPosition="above">
                {{ item?.view }}</div>
            </div>
          </div>
          <div *ngIf="style?.layout?.spacing?.top" class="prop-row">
            <span class="prop-label">Padding Top</span>
            <div class="pills pills-spacing">
              <div *ngFor="let item of spacingType; let i = index" (click)="changeSpacingTop(item.type)"
                [ngClass]="{'pill-active': style?.layout?.spacing?.top === item?.type, 'pill-left': i === 0, 'pill-right': i === spacingType.length - 1}"
                [matTooltip]="item?.view || ''" matTooltipPosition="above">
                {{ item?.view }}</div>
            </div>
          </div>
          <div *ngIf="style?.layout?.spacing?.bottom" class="prop-row">
            <span class="prop-label">Padding Bottom</span>
            <div class="pills pills-spacing">
              <div *ngFor="let item of spacingType; let i = index" (click)="changeSpacingBottom(item.type)"
                [ngClass]="{'pill-active': style?.layout?.spacing?.bottom === item?.type, 'pill-left': i === 0, 'pill-right': i === spacingType.length - 1}"
                [matTooltip]="item?.view || ''" matTooltipPosition="above">
                {{ item?.view }}</div>
            </div>
          </div>
          <div *ngIf="style?.layout?.spacingAround" class="prop-row">
            <span class="prop-label">Margin</span>
            <div class="pills pills-spacing">
              <div *ngFor="let item of spacingType; let i = index" (click)="style.layout.spacingAround = item?.type"
                [ngClass]="{'pill-active': style?.layout?.spacingAround === item?.type, 'pill-left': i === 0, 'pill-right': i === spacingType.length - 1}"
                [matTooltip]="item?.view || ''" matTooltipPosition="above">
                {{ item?.view }}</div>
            </div>
          </div>
        </ng-container>

        <!-- Content Alignment -->
        <ng-container *ngIf="style?.layout?.align">
          <div class="design-group__divider"></div>
          <div class="prop-row">
          <p class="prop-label">Content alignment</p>
          <div class="pills">
            <div class="pill-left" style="flex:1;justify-content:center;" (click)="changeTextAlignment('left')"
              [ngClass]="{'pill-active': style?.layout?.align === 'left'}" matTooltip="Left" matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                <path d="M4 3c-.55228 0-1 .44772-1 1v12c0 .5523.44772 1 1 1s1-.4477 1-1V4c0-.55228-.44772-1-1-1Z" />
                <path fill-rule="evenodd"
                  d="M8 6c-.55228 0-1 .44772-1 1v6c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1V7c0-.55228-.4477-1-1-1H8Zm1 2v4h6V8H9Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="pill-mid" style="flex:1;justify-content:center;" (click)="changeTextAlignment('center')"
              [ngClass]="{'pill-active': style?.layout?.align === 'center'}" matTooltip="Center"
              matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                <path fill-rule="evenodd"
                  d="M14 6c.5523 0 1 .44772 1 1v6c0 .5523-.4477 1-1 1h-3v2c0 .5523-.4477 1-1 1-.55228 0-1-.4477-1-1v-2H6c-.55228 0-1-.4477-1-1V7c0-.55228.44772-1 1-1h3V4c0-.55228.44772-1 1-1 .5523 0 1 .44772 1 1v2h3Zm-7 6V8h6v4H7Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="pill-right" style="flex:1;justify-content:center;" (click)="changeTextAlignment('right')"
              [ngClass]="{'pill-active': style?.layout?.align === 'right'}" matTooltip="Right"
              matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                <path d="M16 3c-.5523 0-1 .44772-1 1v12c0 .5523.4477 1 1 1s1-.4477 1-1V4c0-.55228-.4477-1-1-1Z" />
                <path fill-rule="evenodd"
                  d="M4 6c-.55228 0-1 .44772-1 1v6c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1V7c0-.55228-.4477-1-1-1H4Zm1 2v4h6V8H5Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
          </div>
          </div>
        </ng-container>

        <!-- Vertical Alignment -->
        <ng-container *ngIf="style?.hasOwnProperty('contentAlignment')">
          <div class="design-group__divider"></div>
          <div class="prop-row">
          <p class="prop-label">Vertical alignment</p>
          <div class="pills">
            <div class="pill-left" style="flex:1;justify-content:center;"
              (click)="changeContentAlignmentItem('top')"
              [ngClass]="{'pill-active': style?.contentAlignment === 'top'}"
              matTooltip="Top" matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                <rect x="3" y="2" width="14" height="2" rx="0.5" />
                <rect x="3" y="6" width="14" height="2" rx="0.5" />
                <rect x="3" y="9.5" width="9" height="2" rx="0.5" />
              </svg>
            </div>
            <div class="pill-mid" style="flex:1;justify-content:center;" (click)="changeContentAlignmentItem('center')"
              [ngClass]="{'pill-active': style?.contentAlignment === 'center'}" matTooltip="Center"
              matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                <rect x="3" y="7" width="14" height="2" rx="0.5" />
                <rect x="3" y="10.5" width="9" height="2" rx="0.5" />
              </svg>
            </div>
            <div class="pill-right" style="flex:1;justify-content:center;"
              (click)="changeContentAlignmentItem('bottom')"
              [ngClass]="{'pill-active': style?.contentAlignment === 'bottom'}" matTooltip="Bottom"
              matTooltipPosition="above">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                <rect x="3" y="8" width="14" height="2" rx="0.5" />
                <rect x="3" y="11.5" width="9" height="2" rx="0.5" />
                <rect x="3" y="16" width="14" height="2" rx="0.5" />
              </svg>
            </div>
          </div>
          </div>
        </ng-container>

        <!-- Content Background -->
        <ng-container *ngIf="style?.contentBackground">
          <div class="design-group__divider"></div>
          <p class="section-heading">Content Background</p>
          <div class="prop-row">
            <span class="prop-label">Display</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.contentBackground.display" role="switch"
              [class.active]="style?.contentBackground?.display">
          </div>
          <ng-container *ngIf="style?.contentBackground?.display">
            <mat-form-field appearance="outline" style="width:100%;margin-top:8px;">
              <mat-select [(ngModel)]="style.contentBackground.style">
                <ng-container *ngFor="let item of contentBackgroundType">
                  <mat-option [value]="item?.type">{{item?.type | titlecase}}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>

        <!-- Border Bottom -->
        <div *ngIf="style?.border">
          <div class="design-group__divider"></div>
          <div class="prop-row">
            <span class="section-heading mb-0">Border Bottom</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.border.display"
              (ngModelChange)="changeBorder()" role="switch" [class.active]="style?.border?.display">
          </div>
          <div *ngIf="style?.border?.display" class="mt-10">
            <div class="prop-row">
              <span class="prop-label">Type</span>
              <div class="pills">
                <div (click)="changeBorderType('DASHED')"
                  [ngClass]="{'pill-active': style?.border?.type === 'DASHED', 'pill-left': true}"
                  matTooltip="Dashed" matTooltipPosition="above">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                    <line x1="2" y1="7" x2="7" y2="7" stroke-dasharray="0"/>
                    <line x1="10" y1="7" x2="14" y2="7"/>
                    <line x1="17" y1="7" x2="22" y2="7"/>
                  </svg>
                </div>
                <div (click)="changeBorderType('SOLID')"
                  [ngClass]="{'pill-active': style?.border?.type === 'SOLID', 'pill-right': true}"
                  matTooltip="Solid" matTooltipPosition="above">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                    <line x1="2" y1="7" x2="22" y2="7"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="color-field mt-10">
              <input type="color" class="color-swatch" [(ngModel)]="style.border.color"
                (ngModelChange)="changeBorder()">
              <input type="text" class="color-code-input" [(ngModel)]="style.border.color" disabled>
            </div>
            <div class="prop-row mt-10">
              <span class="prop-label">Thickness</span>
              <div class="slider-inline">
                <mat-slider style="width:90px;" [max]="borderMax" [min]="min" [step]="step">
                  <input matSliderThumb [(ngModel)]="style.border.thickness" (ngModelChange)="changeBorder()">
                </mat-slider>
                <span class="slider-val">{{style?.border?.thickness}}px</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <ng-container *ngIf="style?.hasOwnProperty('devider')">
          <div class="design-group__divider"></div>
          <div class="prop-row">
            <span class="section-heading mb-0">Divider</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="style.devider.display" role="switch"
              [class.active]="style?.devider?.display" (ngModelChange)="changeBorderStatus()">
          </div>
          <div *ngIf="style?.devider?.display" class="mt-10">
            <div class="divider-preview" (click)="openDividerList()">
              <span class="divider-change-btn">Change</span>
              <div class="divider-shape"
                [style.transform]="dividerList[style?.devider?.deviderType]?.rotate ? 'rotate(180deg)' : ''">
                <svg fill="#9CA3AF"
                  [style.transform]="dividerList[style?.devider?.deviderType]?.rotateY ? 'rotateY(180deg)' : ''"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                  <path [attr.d]="dividerList[style?.devider?.deviderType]?.svg"></path>
                </svg>
              </div>
              <div class="divider-base"></div>
            </div>
          </div>
        </ng-container>

        <!-- Animation and Motion -->
        <ng-container *ngIf="style?.hasOwnProperty('animation') && style?.animation">
          <div class="design-group__divider"></div>
          <p class="section-heading">Animation and Motion</p>

          <div class="section-row toggle-row">
            <span class="row-label">Animation</span>
            <input class="toggle-input" type="checkbox" role="switch" [class.active]="style.animation.type !== 'none'"
              [checked]="style.animation.type !== 'none'" (change)="toggleAnimation($event)">
          </div>

          <ng-container *ngIf="style.animation.type !== 'none'">
            <div class="pills pills-full mt-6">
              <!-- Slide Left -->
              <div (click)="style.animation.type = 'left'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'left', 'pill-left': true}"
                matTooltip="Slide Left" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 12H5m7-7-7 7 7 7"/></svg>
              </div>
              <!-- Slide Up -->
              <div (click)="style.animation.type = 'top'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'top'}"
                matTooltip="Slide Up" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 19V5m-7 7 7-7 7 7"/></svg>
              </div>
              <!-- Slide Right -->
              <div (click)="style.animation.type = 'right'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'right'}"
                matTooltip="Slide Right" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-7 7 7-7-7-7"/></svg>
              </div>
              <!-- Slide Down -->
              <div (click)="style.animation.type = 'bottom'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'bottom', 'pill-right': true}"
                matTooltip="Slide Down" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 5v14m7-7-7 7-7-7"/></svg>
              </div>
            </div>
            <div class="pills pills-full mt-6">
              <!-- Fade In -->
              <div (click)="style.animation.type = 'fadeIn'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'fadeIn', 'pill-left': true}"
                matTooltip="Fade In" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path stroke-linecap="round" d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
              </div>
              <!-- Zoom In -->
              <div (click)="style.animation.type = 'zoom'; changeAnimationType()"
                [ngClass]="{'pill-active': style?.animation?.type === 'zoom', 'pill-right': true}"
                matTooltip="Zoom In" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>
              </div>
            </div>
            <div class="prop-row mt-10">
              <span class="prop-label">Speed</span>
              <div class="pills">
                <div *ngFor="let speed of animationSpeed; let i = index" (click)="changeAnimationSpeed(speed.type)"
                  [ngClass]="{'pill-active': speed?.type === style?.animation?.speed, 'pill-left': i == 0, 'pill-right': i == animationSpeed.length - 1}"
                  [matTooltip]="(speed?.type | titlecase) || ''" matTooltipPosition="above">
                  {{speed?.type | titlecase}}
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </ng-container>

  <!-- ── Headline group (header only, visible when headline display is on) ── -->
  <ng-container *ngIf="sectionType === 'header' && style?.headline?.display">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('headline')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 6h16M4 12h10M4 18h12"/>
          <polyline points="17 9 21 6 17 3"/>
        </svg>
        <span class="design-group__title">Headline</span>
        <svg class="design-group__chevron" [class.open]="openSections['headline']"
             xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['headline']">
        <p class="prop-label" style="margin-bottom:8px;">Color</p>
        <div class="color-field">
          <input type="color" class="color-swatch" [(ngModel)]="style.headline.color">
          <input type="text" class="color-code-input" [(ngModel)]="style.headline.color" disabled>
        </div>
        <mat-form-field appearance="outline" style="width:100%;margin-top:10px;">
          <mat-select [(ngModel)]="style.headline.headlineAnimationType">
            <ng-container *ngFor="let item of headlineanimationType">
              <mat-option [value]="item?.type">{{item?.type | titlecase}}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </ng-container>

  <!-- ── Countdown Banner group (header only, visible when countdown display is on) ── -->
  <ng-container *ngIf="sectionType === 'header' && style?.countdown?.display && content?.countdownBanner?.styles">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('countdown')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12 6 12 12 16 14"/>
        </svg>
        <span class="design-group__title">Countdown Banner</span>
        <svg class="design-group__chevron" [class.open]="openSections['countdown']"
             xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['countdown']">
        <p class="prop-label" style="margin-bottom:8px;">Background Color</p>
        <div class="color-field">
          <input type="color" class="color-swatch"
            [(ngModel)]="content.countdownBanner.styles.background.color"
            (ngModelChange)="changeCountdownBackground()">
          <input type="text" class="color-code-input"
            [(ngModel)]="content.countdownBanner.styles.background.color"
            (ngModelChange)="changeCountdownBackground()" disabled>
        </div>
        <p class="prop-label mt-10" style="margin-bottom:8px;">Accent Color</p>
        <div class="color-field">
          <input type="color" class="color-swatch"
            [(ngModel)]="content.countdownBanner.styles.background.accentColor"
            (ngModelChange)="changeCountdownBackground()">
          <input type="text" class="color-code-input"
            [(ngModel)]="content.countdownBanner.styles.background.accentColor"
            (ngModelChange)="changeCountdownBackground()" disabled>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ② Tag -->
  <ng-container *ngIf="content?.hasOwnProperty('tag')">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('tag')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2H7a2 2 0 0 0-2 2v5l10 10 7-7L12 2Z" />
          <circle cx="7.5" cy="7.5" r="1.5" />
        </svg>
        <span class="design-group__badge" style="display:none">3</span>
        <span class="design-group__title">Tag</span>
        <svg class="design-group__chevron" [class.open]="openSections['tag']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['tag']">
        <p class="prop-label" style="margin-bottom:8px;">Color</p>
        <div class="color-field">
          <input type="color" class="color-swatch" [(ngModel)]="style.background.accentColor"
            (ngModelChange)="changeAccentColor()">
          <input type="text" class="color-code-input" [(ngModel)]="style.background.accentColor" disabled>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ③ Heading -->
  <ng-container *ngIf="style?.layout?.headingSpacing">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('typography')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 12h12M6 4h12M6 20h12" />
          <path d="M4 4v16" />
        </svg>
        <span class="design-group__badge" style="display:none">3</span>
        <span class="design-group__title">Heading</span>
        <svg class="design-group__chevron" [class.open]="openSections['typography']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['typography']">
        <div class="prop-row">
          <p class="prop-label">Margin Bottom</p>
          <div class="pills pills-spacing">
            <div *ngFor="let item of spacingType; let i = index" (click)="changeHeadingSpacing(item.type)"
              [ngClass]="{'pill-active': style?.layout?.headingSpacing === item?.type, 'pill-left': i === 0, 'pill-right': i === spacingType.length - 1}"
              [matTooltip]="item.view || ''" matTooltipPosition="above" style="flex:1;justify-content:center;">{{ item?.view }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ④ Item -->
  <ng-container
    *ngIf="sectionType !== 'header' && (content?.display?.hasOwnProperty('showCard') || content?.display?.hasOwnProperty('showHoverEffect') || (!hasContentImage() && showImageStyles()) || (style?.size && style?.gridStyle != 'Style2') || style?.hasOwnProperty('logoType') || style?.hasOwnProperty('inputOpacity') || style?.hasOwnProperty('containerHeight') || style?.hasOwnProperty('containerWidth') || style?.hasOwnProperty('logoPosition') || style?.hasOwnProperty('hoverPlay') || style?.hasOwnProperty('muteVideos') || (style?.hasOwnProperty('autoPlay') && !content?.display?.showImage) || style?.hasOwnProperty('showText') || (!hasContentImage() && style?.textPosition) || style?.contentAnimation)">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('item')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
        <span class="design-group__badge" style="display:none">4</span>
        <span class="design-group__title">{{content?.listItem?.label || 'List Item'}}</span>
        <svg class="design-group__chevron" [class.open]="openSections['item']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['item']">

        <!-- Item Layout (includes content overlay controls) -->
        <ng-container
          *ngIf="content?.display?.hasOwnProperty('showCard') || (style?.size && style?.gridStyle != 'Style2') || (!hasContentImage() && style?.textPosition && style?.image?.fit != ImageFit.Contain && !content?.display?.showIcon)">
          <p class="item-sub-label">Layout</p>
          <ng-container
            *ngIf="!hasContentImage() && style?.textPosition && style?.image?.fit != ImageFit.Contain && !content?.display?.showIcon">
            <div>
            <p class="prop-label" style="margin-bottom:6px;">Text position</p>
            <div class="pills pills-full">
              <div *ngFor="let position of textPosition; let i = index"
                (click)="style.textPosition = position?.type; changeTextPosition()"
                [ngClass]="{'pill-active': style?.textPosition === position?.type, 'pill-left': i == 0, 'pill-right': i == textPosition.length - 1}"
                [matTooltip]="(position?.type | titlecase) || ''" matTooltipPosition="above">
                {{position?.type | titlecase}}
              </div>
            </div>
            </div>
            <div
              *ngIf="style?.textPosition === TextPosition.TOP_OF_IMAGE || style?.textPosition === TextPosition.COVERING_IMAGE"
              class="mt-10">
              <p class="prop-label" style="margin-bottom:6px;">Opacity color</p>
              <div class="color-field">
                <input type="color" class="color-swatch" [(ngModel)]="style.textBackground.color"
                  (ngModelChange)="changeTextBackground()">
                <input type="text" class="color-code-input" [(ngModel)]="style.textBackground.color" disabled>
              </div>
              <div class="slider-row mt-8">
                <span class="prop-label mb-0" style="width:auto;flex-shrink:0;">Opacity</span>
                <mat-slider style="flex:1;margin:0 8px;" [max]="max" [min]="min" [step]="step">
                  <input matSliderThumb [(ngModel)]="style.textBackground.amount"
                    (ngModelChange)="changeTextBackground()">
                </mat-slider>
                <span class="slider-val">{{style?.textBackground?.amount}}%</span>
              </div>
            </div>
            <div class="design-group__divider"
              *ngIf="content?.display?.hasOwnProperty('showCard') || (style?.size && style?.gridStyle != 'Style2')">
            </div>
          </ng-container>
          <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showCard')">
            <span class="row-label">Card Form</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showCard" role="switch"
              [class.active]="content?.display?.showCard">
          </div>
          <div *ngIf="style?.size && style?.gridStyle != 'Style2'" class="prop-row">
            <span class="prop-label">Item size</span>
            <div class="pills">
              <div *ngFor="let size of cardSize; let i = index" (click)="changeCardSize(size.type)"
                [ngClass]="{'pill-active': style?.size === size?.type, 'pill-left': i == 0, 'pill-right': i == cardSize.length - 1}"
                [matTooltip]="size?.type || ''" matTooltipPosition="above">
                {{size?.type}}</div>
            </div>
          </div>
          <div class="mt-12" *ngIf="content.display.showLink">
            <div class="section-row">
              <span class="row-label">
                Link type
                <mat-icon #tooltip="matTooltip" class="info-icon"
                  matTooltip="Select Button to display a clickable button linked to a URL. Select List to show a list of items, each potentially linked to a URL"
                  matTooltipPosition="right" matTooltipClass="infotooltip" (click)="tooltip.toggle()">info</mat-icon>
              </span>
              <div class="seg-buttons">
                <div class="seg-left" (click)="content.display.linkType = 'Button'"
                  [ngClass]="{'seg-selected': content.display.linkType === 'Button'}">Button</div>
                <div class="seg-right" (click)="content.display.linkType = 'List Item'"
                  [ngClass]="{'seg-selected': content.display.linkType === 'List Item'}">List Item</div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Item Media -->
        <ng-container
          *ngIf="showImageStyles() || style?.hasOwnProperty('hoverPlay') || style?.hasOwnProperty('muteVideos') || (style?.hasOwnProperty('autoPlay') && !content?.display?.showImage) || style?.hasOwnProperty('showText')">
          <div class="design-group__divider"
            *ngIf="content?.display?.hasOwnProperty('showCard') || content?.display?.hasOwnProperty('showHoverEffect') || style?.contentAnimation">
          </div>
          <p class="item-sub-label">Media</p>

          <ng-container *ngIf="showImageStyles() && !hasContentImage()">
            <div *ngIf="style?.image && style?.pricingStyle != 'STYLE2'">
              <div
                *ngIf="style?.image?.hasOwnProperty('fit') && (!style?.hasOwnProperty('textPosition') || style?.textPosition === TextPosition.BELOW_IMAGE)"
                class="prop-row">
                <span class="prop-label">Image fit</span>
                <div class="pills">
                  <div (click)="style.image.fit = 'Cover'; changeImageStyle()"
                    [ngClass]="{'pill-active': style?.image?.fit === 'Cover', 'pill-left': true}"
                    matTooltip="Cover" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="2" y="2" width="20" height="20" rx="2" fill="currentColor" opacity="0.25"/>
                      <rect x="2" y="2" width="20" height="20" rx="2"/>
                    </svg>
                  </div>
                  <div (click)="style.image.fit = 'Contain'; changeImageStyle()"
                    [ngClass]="{'pill-active': style?.image?.fit === 'Contain', 'pill-right': true}"
                    matTooltip="Contain" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="2" y="2" width="20" height="20" rx="2" stroke-dasharray="2 2"/>
                      <rect x="5" y="5" width="14" height="14" rx="1"/>
                    </svg>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="style?.hasOwnProperty('borderLessImage')">
                <div class="prop-row mt-10">
                  <span class="prop-label">Borderless image</span>
                  <input class="toggle-input" type="checkbox" [(ngModel)]="style.borderLessImage" role="switch"
                    [class.active]="style?.borderLessImage">
                </div>
              </ng-container>
              <div
                *ngIf="style?.image?.hasOwnProperty('ratio') && style?.image?.fit != 'Contain' && style?.textPosition != 'Covering image'"
                class="prop-row mt-10">
                <p class="prop-label">Aspect ratio</p>
                <div class="pills">
                  <div *ngFor="let item of aspectRatio; let i = index"
                    (click)="style.image.ratio = item.value; changeImageStyle()"
                    [ngClass]="{'pill-active': style?.image?.ratio === item.value, 'pill-left': i === 0, 'pill-right': i === aspectRatio.length - 1}"
                    [matTooltip]="item.key | titlecase" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                      stroke="currentColor" stroke-width="2">
                      <rect [attr.x]="item.rect.x" [attr.y]="item.rect.y" [attr.width]="item.rect.w"
                        [attr.height]="item.rect.h" rx="1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="style?.corners" class="prop-row mt-10">
              <p class="prop-label">Corner radius</p>
              <div class="pills">
                <div *ngFor="let corner of corners; let i = index" (click)="changeCorners(corner.type)"
                  [ngClass]="{'pill-active': style?.corners === corner.type, 'pill-left': i === 0, 'pill-right': i === corners.length - 1}"
                  [matTooltip]="corner.type" matTooltipPosition="above">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <rect x="3" y="3" width="18" height="18" [attr.rx]="corner.rx ?? 0" />
                  </svg>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="style?.hasOwnProperty('hoverPlay') || style?.hasOwnProperty('muteVideos') || (style?.hasOwnProperty('autoPlay') && !content?.display?.showImage)">
            <div class="prop-row" [class.mt-10]="showImageStyles()" *ngIf="style?.hasOwnProperty('hoverPlay')">
              <span class="prop-label">Play on hover</span>
              <input class="toggle-input" type="checkbox" [(ngModel)]="style.hoverPlay" role="switch"
                [class.active]="style?.hoverPlay">
            </div>
            <div class="prop-row" *ngIf="style?.hasOwnProperty('muteVideos')">
              <span class="prop-label">Mute videos</span>
              <input class="toggle-input" type="checkbox" [(ngModel)]="style.muteVideos" role="switch"
                [class.active]="style?.muteVideos">
            </div>
            <div class="prop-row" *ngIf="style?.hasOwnProperty('autoPlay')">
              <span class="prop-label">Auto play videos</span>
              <input [(ngModel)]="style.autoPlay" (ngModelChange)="autoplayVideos()" class="toggle-input" role="switch"
                type="checkbox" [class.active]="style?.autoPlay">
            </div>
          </ng-container>

          <ng-container *ngIf="style?.hasOwnProperty('showText')">
            <div class="prop-row mt-10">
              <span class="prop-label">Show Text</span>
              <input class="toggle-input" type="checkbox" [(ngModel)]="style.showText" role="switch"
                [class.active]="style?.showText">
            </div>
          </ng-container>
        </ng-container>

        <!-- Item Animation and Motion -->
        <ng-container *ngIf="content?.display?.hasOwnProperty('showHoverEffect') || style?.contentAnimation">
          <div class="design-group__divider"
            *ngIf="content?.display?.hasOwnProperty('showCard') || (style?.size && style?.gridStyle != 'Style2') || (!hasContentImage() && style?.textPosition && style?.image?.fit != ImageFit.Contain && !content?.display?.showIcon)">
          </div>
          <p class="item-sub-label">Animation and Motion</p>
          <div *ngIf="style?.contentAnimation" class="mb-8">
            <mat-form-field appearance="outline" style="width:100%;">
              <mat-select [(ngModel)]="style.contentAnimation" (ngModelChange)="changeContentAnimation()">
                <ng-container *ngFor="let item of contentAnimation">
                  <mat-option [value]="item?.type">{{item?.type | titlecase}}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showHoverEffect')">
            <span class="row-label">Hover Effect</span>
            <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showHoverEffect" role="switch"
              [class.active]="content?.display?.showHoverEffect">
          </div>
        </ng-container>


        <!-- Item Settings -->
        <ng-container
          *ngIf="style?.hasOwnProperty('logoType') || style?.hasOwnProperty('inputOpacity') || style?.hasOwnProperty('containerHeight') || style?.hasOwnProperty('containerWidth') || style?.hasOwnProperty('logoPosition')">
          <div class="design-group__divider"></div>
          <p class="item-sub-label">Settings</p>
          <div *ngIf="style?.hasOwnProperty('logoType')" class="prop-row">
            <span class="prop-label">Box type</span>
            <div class="pills">
              <div *ngFor="let box of logoBoxType; let i = index" (click)="style.logoType = box?.type"
                [ngClass]="{'pill-active': box?.type === style?.logoType, 'pill-left': i == 0, 'pill-right': i == logoBoxType.length - 1}">
                {{box?.type | titlecase}}</div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('logoPosition') && content?.display?.showIcon" class="prop-row">
            <span class="prop-label">Logo position</span>
            <div class="pills">
              <div *ngFor="let position of logoPosition; let i = index" (click)="style.logoPosition = position?.type"
                [ngClass]="{'pill-active': style?.logoPosition === position?.type, 'pill-left': i == 0, 'pill-right': i == logoPosition.length - 1}">
                {{position?.type | titlecase}}</div>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('containerHeight')" class="mt-10">
            <p class="prop-label">Height</p>
            <div class="slider-row mt-6">
              <mat-slider style="flex:1;" max="400" [min]="min" [step]="step">
                <input matSliderThumb [(ngModel)]="style.containerHeight" (ngModelChange)="changeBorder()">
              </mat-slider>
              <span class="slider-val">{{style?.containerHeight}}px</span>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('containerWidth')" class="mt-10">
            <p class="prop-label">Width</p>
            <div class="slider-row mt-6">
              <mat-slider style="flex:1;" max="400" [min]="min" [step]="step">
                <input matSliderThumb [(ngModel)]="style.containerWidth" (ngModelChange)="changeBorder()">
              </mat-slider>
              <span class="slider-val">{{style?.containerWidth}}px</span>
            </div>
          </div>
          <div *ngIf="style?.hasOwnProperty('inputOpacity')" class="mt-10">
            <p class="prop-label">Field input opacity</p>
            <div class="slider-row mt-6">
              <mat-slider style="flex:1;" [max]="max" [min]="min" [step]="step">
                <input matSliderThumb [(ngModel)]="style.inputOpacity">
              </mat-slider>
              <span class="slider-val">{{style?.inputOpacity}}%</span>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </ng-container>

  <!-- ⑤ Media (component-level image: banner, text_image, faq, appointment, etc.) -->
  <ng-container *ngIf="hasContentImage() && (showImageStyles() || style?.textPosition)">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('media')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
        <span class="design-group__badge" style="display:none">4</span>
        <span class="design-group__title">Media</span>
        <svg class="design-group__chevron" [class.open]="openSections['media']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['media']">

        <!-- Image Fit / Ratio / Borderless / Corners -->
        <ng-container *ngIf="showImageStyles()">
          <div *ngIf="style?.image && style?.pricingStyle != 'STYLE2'">
            <div
              *ngIf="style?.image?.hasOwnProperty('fit') && (!style?.hasOwnProperty('textPosition') || style?.textPosition === TextPosition.BELOW_IMAGE)"
              class="prop-row">
              <span class="prop-label">Image fit</span>
              <div class="pills">
                <div *ngFor="let item of imageFit; let i = index"
                  (click)="style.image.fit = item?.type; changeImageStyle()"
                  [ngClass]="{'pill-active': item?.type === style?.image?.fit, 'pill-left': i === 0, 'pill-right': i === imageFit.length - 1}">
                  {{ item?.type | titlecase }}
                </div>
              </div>
            </div>
            <ng-container *ngIf="style?.hasOwnProperty('borderLessImage')">
              <div class="prop-row mt-10">
                <span class="prop-label">Borderless image</span>
                <input class="toggle-input" type="checkbox" [(ngModel)]="style.borderLessImage" role="switch"
                  [class.active]="style?.borderLessImage">
              </div>
            </ng-container>
            <div class="media-ratio-grid"
              *ngIf="(style?.image?.hasOwnProperty('ratio') && style?.image?.fit != 'Contain' && style?.textPosition != 'Covering image') || style?.corners">
              <div
                *ngIf="style?.image?.hasOwnProperty('ratio') && style?.image?.fit != 'Contain' && style?.textPosition != 'Covering image'">
                <p class="prop-label">Aspect ratio</p>
                <div class="pills pills-full mt-6">
                  <div *ngFor="let item of aspectRatio; let i = index"
                    (click)="style.image.ratio = item.value; changeImageStyle()"
                    [ngClass]="{'pill-active': style?.image?.ratio === item.value, 'pill-left': i === 0, 'pill-right': i === aspectRatio.length - 1}"
                    [matTooltip]="item.key | titlecase" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                      stroke="currentColor" stroke-width="2">
                      <rect [attr.x]="item.rect.x" [attr.y]="item.rect.y" [attr.width]="item.rect.w"
                        [attr.height]="item.rect.h" rx="1" />
                    </svg>
                  </div>
                </div>
              </div>
              <div *ngIf="style?.corners">
                <p class="prop-label">Corner radius</p>
                <div class="pills pills-full mt-6">
                  <div *ngFor="let corner of corners; let i = index" (click)="changeCorners(corner.type)"
                    [ngClass]="{'pill-active': style?.corners === corner.type, 'pill-left': i === 0, 'pill-right': i === corners.length - 1}"
                    [matTooltip]="corner.type" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                      stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="18" height="18" [attr.rx]="corner.rx ?? 0" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Content Overlay (text position relative to component image) -->
        <ng-container
          *ngIf="style?.textPosition && style?.image?.fit != ImageFit.Contain && !content?.display?.showIcon">
          <div class="design-group__divider" *ngIf="showImageStyles()"></div>
          <p class="item-sub-label">Overlay</p>
          <p class="prop-label" style="margin-bottom:6px;">Text position</p>
          <div class="pills pills-full">
            <div *ngFor="let position of textPosition; let i = index"
              (click)="style.textPosition = position?.type; changeTextPosition()"
              [ngClass]="{'pill-active': style?.textPosition === position?.type, 'pill-left': i == 0, 'pill-right': i == textPosition.length - 1}">
              {{position?.type | titlecase}}
            </div>
          </div>
          <div
            *ngIf="style?.textPosition === TextPosition.TOP_OF_IMAGE || style?.textPosition === TextPosition.COVERING_IMAGE"
            class="mt-10">
            <p class="prop-label" style="margin-bottom:6px;">Opacity color</p>
            <div class="color-field">
              <input type="color" class="color-swatch" [(ngModel)]="style.textBackground.color"
                (ngModelChange)="changeTextBackground()">
              <input type="text" class="color-code-input" [(ngModel)]="style.textBackground.color" disabled>
            </div>
            <div class="slider-row mt-8">
              <span class="prop-label mb-0" style="width:auto;flex-shrink:0;">Opacity</span>
              <mat-slider style="flex:1;margin:0 8px;" [max]="max" [min]="min" [step]="step">
                <input matSliderThumb [(ngModel)]="style.textBackground.amount"
                  (ngModelChange)="changeTextBackground()">
              </mat-slider>
              <span class="slider-val">{{style?.textBackground?.amount}}%</span>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </ng-container>

  <!-- Table -->
  <ng-container *ngIf="content?.hasOwnProperty('columnCellBorder')">
    <div class="design-group">
      <div class="design-group__header" (click)="toggleSection('table')">
        <svg class="design-group__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <path d="M3 9h18M3 15h18M9 3v18"/>
        </svg>
        <span class="design-group__title">Table</span>
        <svg class="design-group__chevron" [class.open]="openSections['table']" xmlns="http://www.w3.org/2000/svg"
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>
      <div class="design-group__body" *ngIf="openSections['table']">
        <div class="prop-row">
          <span class="prop-label">Column Cell Border</span>
          <input [(ngModel)]="content.columnCellBorder" class="toggle-input" role="switch" type="checkbox"
            [class.active]="content.columnCellBorder">
        </div>
      </div>
    </div>
  </ng-container>

</section>


<!-- ─── Header Layout SVG wireframe templates ─────────── -->

<!-- Header1: Logo Left, Nav Right -->
<ng-template #svgH1Mega>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Logo left -->
    <rect x="7" y="12" width="18" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Nav right -->
    <rect x="50" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="64" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="78" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Mega: 2x2 grid indicator -->
    <rect x="97" y="13" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="103" y="13" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="97" y="20" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="103" y="20" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
  </svg>
</ng-template>

<ng-template #svgH1Drop>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Logo left -->
    <rect x="7" y="12" width="18" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Nav right -->
    <rect x="50" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="64" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="78" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Dropdown chevron under last nav item -->
    <path d="M86 21 L89 24 L92 21" stroke="#D1D5DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <!-- CTA button -->
    <rect x="97" y="12" width="16" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
  </svg>
</ng-template>

<!-- Header2: Logo Right, Nav Left -->
<ng-template #svgH2Mega>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Nav left -->
    <rect x="8" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="22" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="36" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Logo right -->
    <rect x="95" y="12" width="18" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Mega: 2x2 grid indicator (center) -->
    <rect x="55" y="13" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="61" y="13" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="55" y="20" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
    <rect x="61" y="20" width="4" height="4" rx="0.5" fill="#D1D5DB"/>
  </svg>
</ng-template>

<ng-template #svgH2Drop>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Nav left -->
    <rect x="8" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="22" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="36" y="16" width="10" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Logo right -->
    <rect x="95" y="12" width="18" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Dropdown chevron -->
    <path d="M44 21 L47 24 L50 21" stroke="#D1D5DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <!-- CTA button -->
    <rect x="60" y="12" width="16" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
  </svg>
</ng-template>

<!-- Header3: Logo Left, Centered Nav, CTA Right -->
<ng-template #svgH3Mega>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Logo left -->
    <rect x="5" y="12" width="14" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Centered nav -->
    <rect x="37" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="50" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="63" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- CTA right -->
    <rect x="86" y="12" width="14" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
    <!-- Mega: 2x2 indicator (near CTA) -->
    <rect x="103" y="13" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="108" y="13" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="103" y="19" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="108" y="19" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
  </svg>
</ng-template>

<ng-template #svgH3Drop>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- Logo left -->
    <rect x="5" y="12" width="14" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Centered nav -->
    <rect x="37" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="50" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="63" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Dropdown chevron under last nav item -->
    <path d="M70 21 L73 24 L76 21" stroke="#D1D5DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <!-- CTA right -->
    <rect x="86" y="12" width="14" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
    <rect x="103" y="14" width="12" height="9" rx="1.5" fill="#F3F4F6" stroke="#D1D5DB"/>
  </svg>
</ng-template>

<!-- Header4: Logo Right, Centered Nav, CTA Left -->
<ng-template #svgH4Mega>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- CTA left -->
    <rect x="5" y="12" width="14" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
    <!-- Centered nav -->
    <rect x="37" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="50" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="63" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Logo right -->
    <rect x="101" y="12" width="14" height="13" rx="2" fill="#9CA3AF"/>
    <!-- Mega: 2x2 indicator -->
    <rect x="78" y="13" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="83" y="13" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="78" y="19" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
    <rect x="83" y="19" width="3.5" height="3.5" rx="0.5" fill="#D1D5DB"/>
  </svg>
</ng-template>

<ng-template #svgH4Drop>
  <svg viewBox="0 0 120 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="119" height="37" rx="3" fill="#F9FAFB" stroke="#E5E7EB"/>
    <!-- CTA left -->
    <rect x="5" y="12" width="14" height="13" rx="2" fill="#F3F4F6" stroke="#D1D5DB"/>
    <!-- Centered nav -->
    <rect x="37" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="50" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <rect x="63" y="16" width="9" height="3" rx="1.5" fill="#D1D5DB"/>
    <!-- Dropdown chevron -->
    <path d="M70 21 L73 24 L76 21" stroke="#D1D5DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <!-- Logo right -->
    <rect x="101" y="12" width="14" height="13" rx="2" fill="#9CA3AF"/>
    <rect x="79" y="14" width="12" height="9" rx="1.5" fill="#F3F4F6" stroke="#D1D5DB"/>
  </svg>
</ng-template>